/**
 * @description Downloads a CSV file
 * @param data - The data to be downloaded
 * @param fileName - The name of the file to be downloaded
 * @returns void
 */
export const downloadCsv = (data: BlobPart, fileName: string) => {
  const blob = new Blob([data], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.style.display = "none";
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
